// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PhotosList-positionRelative-Xu1Ec {
    position: relative;
}

.PhotosList-photoListBgImage-7UGjp {
    background-position: 50% 50%;
    background-repeat: no-repeat;
    background-size: cover;
    width: 100%;
    height: 100%;
    padding-top: 70%;
    border-radius: 4px;
    background-color: var(--secondary-gray-bg);
}

.PhotosList-displayGrid-P44QG {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    grid-gap: 20px;
    margin-top: 30px;
}

.PhotosList-coverPhotoSection-_jEQz {
    color: var(--primary-foreground);
    font-size: 12px;
    background-color: var(--primary-gray-bg);
    display: inline-block;
    position: absolute;
    top: 8px;
    left: 8px;
    padding: 4px 6px;
    border-radius: 4px;
    height: 25px;
    text-align: center;
    line-height: 18px;
}

.PhotosList-tickIcon-brAvx {
    width: 11px;
    height: 8px;
    margin-right: 5px;
}

@media (max-width:1199px) and (min-width: 441px) {
    .PhotosList-displayGrid-P44QG {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media screen and (max-width: 440px) {
    .PhotosList-displayGrid-P44QG {
        grid-template-columns: 100%;
    }
}`, "",{"version":3,"sources":["webpack://./src/components/PhotosList/PhotosList.css"],"names":[],"mappings":"AAAA;IACI,kBAAkB;AACtB;;AAEA;IACI,4BAA4B;IAC5B,4BAA4B;IAC5B,sBAAsB;IACtB,WAAW;IACX,YAAY;IACZ,gBAAgB;IAChB,kBAAkB;IAClB,0CAA0C;AAC9C;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,cAAc;IACd,gBAAgB;AACpB;;AAEA;IACI,gCAAgC;IAChC,eAAe;IACf,wCAAwC;IACxC,qBAAqB;IACrB,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,2BAA2B;IAC/B;AACJ","sourcesContent":[".positionRelative {\n    position: relative;\n}\n\n.photoListBgImage {\n    background-position: 50% 50%;\n    background-repeat: no-repeat;\n    background-size: cover;\n    width: 100%;\n    height: 100%;\n    padding-top: 70%;\n    border-radius: 4px;\n    background-color: var(--secondary-gray-bg);\n}\n\n.displayGrid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    grid-gap: 20px;\n    margin-top: 30px;\n}\n\n.coverPhotoSection {\n    color: var(--primary-foreground);\n    font-size: 12px;\n    background-color: var(--primary-gray-bg);\n    display: inline-block;\n    position: absolute;\n    top: 8px;\n    left: 8px;\n    padding: 4px 6px;\n    border-radius: 4px;\n    height: 25px;\n    text-align: center;\n    line-height: 18px;\n}\n\n.tickIcon {\n    width: 11px;\n    height: 8px;\n    margin-right: 5px;\n}\n\n@media (max-width:1199px) and (min-width: 441px) {\n    .displayGrid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media screen and (max-width: 440px) {\n    .displayGrid {\n        grid-template-columns: 100%;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"positionRelative": `PhotosList-positionRelative-Xu1Ec`,
	"photoListBgImage": `PhotosList-photoListBgImage-7UGjp`,
	"displayGrid": `PhotosList-displayGrid-P44QG`,
	"coverPhotoSection": `PhotosList-coverPhotoSection-_jEQz`,
	"tickIcon": `PhotosList-tickIcon-brAvx`
};
module.exports = ___CSS_LOADER_EXPORT___;
